const TOPICS = [
  { id: 1, name: '明星恋情', count: '3.2万', hot: true },
  { id: 2, name: '综艺翻车', count: '2.8万', hot: true },
  { id: 3, name: '主播违约金', count: '2.5万', hot: true },
  { id: 4, name: '选秀黑幕', count: '2.1万', hot: false },
  { id: 5, name: '影视剧路透', count: '1.9万', hot: false },
  { id: 6, name: '电竞转会', count: '1.7万', hot: true },
  { id: 7, name: '品牌解约潮', count: '1.5万', hot: false },
  { id: 8, name: '饭圈大战', count: '1.4万', hot: true },
  { id: 9, name: '国外吃瓜', count: '1.2万', hot: false },
  { id: 10, name: '考古旧瓜', count: '9.8千', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="section-container">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-accent-100 text-accent-700 mb-3">
            话题标签
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            热门吃瓜话题
          </h2>
          <p className="text-sm text-foreground-500 mt-2">当前最受关注的吃瓜话题标签</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {TOPICS.map((topic) => (
            <a
              key={topic.id}
              href="#cards"
              className={`group inline-flex items-center gap-2 px-4 py-2.5 rounded-full border text-sm font-medium whitespace-nowrap transition-all cursor-pointer ${
                topic.hot
                  ? 'border-primary-200 bg-primary-50 text-primary-700 hover:bg-primary-100 hover:border-primary-300'
                  : 'border-background-300 bg-background-100 text-foreground-600 hover:bg-background-200 hover:border-background-400'
              }`}
            >
              <span>{topic.name}</span>
              {topic.hot && (
                <span className="w-1.5 h-1.5 rounded-full bg-primary-500"></span>
              )}
              <span className="text-xs opacity-60">{topic.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}